<template>
  <div class="innderDiv">
    <div class="filing-card">
      <div class="mainDiv">
        <img style="width: 138px;height: 117px;" src="../../../static/images/mobile-pay-success.png">
      </div>
      <div style="margin: auto;">
        <p class="success-title">恭喜你，支付成功!</p>
        <p class="success-info">请前往终端点击完成按钮进行下一步操作。</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'mobile-pay-success'
    }
</script>

<style scoped>
  .innderDiv {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    background-image: url("../../../static/images/vertical.png");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    cursor: none;
  }

  .filing-card {
    width: 100%;
    height: 100%;
    /* background-image: url("../../../../../../static/images/suit-row-content.png"); */
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 129px;
  }

  .filing-card .smallTitleDiv {
    /* width:80%; */
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 64px auto 0;
    font-size: 48px;
    font-weight: bold;
    color: #fff;
  }

  .filing-card .mainDiv {
    display: flex;
    justify-content: center;
    margin-top: -50px;
  }

  .filing-card .buttonDiv {
    margin-top: 30px;
  }
  .success-title{
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height:25px;
    text-align: center;
    margin: 10px;
  }
  .success-info {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 15px;
    text-align: center;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobile-pay-success.vue